import React from 'react'
import { ThemeContext } from '../../../contexts/theme'

function Logo (props) {
  const themeContext = React.useContext(ThemeContext)

  let link = ''
  if (props.type === 'second') {
    link = themeContext.theme_logo.logo_white
  } else {
    link = themeContext.theme_logo.logo_color
  }

  return <img src={link} alt='' />
}

export default Logo
